import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { ValidationService } from '@sm360/widget-commons-forms';

import PasswordGroup from 'login/components/Library/PasswordGroup/PasswordGroup.jsx';
import LoadingButton from 'login/components/Library/LoadingButton/LoadingButton.jsx';

import AuthenticationService from 'login/services/AuthenticationService/AuthenticationService.js';
import CONSTANT from 'login/constants/constant.js';

class ResetPasswordForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInputs: {
                password: '',
                passwordConfirmation: '',
            },
            formValidation: {
                password: false,
            },
            submitButtonEnabled: true,
            errorCode: '',
        };

        this.passwordRequired = true;

        this.passwordChangeCallback = this.passwordChangeCallback.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    onSubmit(event) {
        event.preventDefault();
    }

    passwordChangeCallback(groupResponse) {
        const state = this.state;
        const isValid = groupResponse.valid;
        const value = groupResponse.value;

        state.formInputs.password = value;
        state.formInputs.passwordConfirmation = value;

        state.formValidation.password = isValid;

        this.setState(state);
    }

    submitForm() {
        this.setState({ errorCode: '' });

        if (!ValidationService.validateForm(this.state.formValidation)) {
            this.setState({
                errorCode: CONSTANT.ERRORS.ACCOUNT.INVALID_PASSWORD,
            });
            return;
        }

        AuthenticationService.resetPassword(this.state.formInputs.password)
            .then(() => {
                this.props.showComponent(false);
            })
            .catch((error) => {
                let errorCode = CONSTANT.ERRORS.ACCOUNT.UNKONW_ERROR_SENDING_PASSWORD_RESET_CODE;
                const response = error.response;

                if (response.status === 400 || response.status === 404 || response.status === -1) {
                    errorCode = CONSTANT.ERRORS.ACCOUNT.INVALID_RESET_CODE;
                }

                this.setState({ errorCode });
            });
    }

    render() {
        let errorMessage = '';
        if (this.state.errorCode) {
            switch (this.state.errorCode) {
                case CONSTANT.ERRORS.ACCOUNT.INVALID_RESET_CODE:
                    errorMessage = LocaleService.t('LOGIN.ERROR_MESSAGE.INVALID_RESET_CODE');
                    break;
                case CONSTANT.ERRORS.ACCOUNT.INVALID_PASSWORD:
                    errorMessage = LocaleService.t('LOGIN.PASSWORD_MIN');
                    break;
                default:
                    errorMessage = LocaleService.t('LOGIN.ERROR_MESSAGE.RESET_PASSWORD_UNKNOWN_ERROR');
            }
        }

        return (
            <div className="ResetPasswordForm">
                <form className="resetPasswordForm" name="resetPasswordForm" onSubmit={this.onSubmit}>
                    <PasswordGroup
                        value={this.state.formInputs.password}
                        valueChange={this.passwordChangeCallback}
                        passwordLabel={LocaleService.t('LOGIN.RESET_PASSWORD.NEW_PASSWORD')}
                        confirmPasswordLabel={LocaleService.t('LOGIN.RESET_PASSWORD.NEW_PASSWORD_CONFIRMATION')}
                    />

                    <div className="error-message">{errorMessage}</div>
                    <LoadingButton
                        text={LocaleService.t('LOGIN.SEND')}
                        btnCallback={() => this.submitForm()}
                        btnEnabled={this.state.submitButtonEnabled}
                    />
                </form>
            </div>
        );
    }
}

ResetPasswordForm.propTypes = {
    showComponent: PropTypes.func.isRequired,
};

ResetPasswordForm.displayName = 'ResetPasswordForm';

export default ResetPasswordForm;
